function init() {

    function showOptions(target) {
        $(target)
            .children(".iama__selectbox--options")
            .toggle();
        $(target)
            .children(".iama__selectbox--chevron-btn")
            .toggleClass("show");
    }


    function hideOptions(target) {
        $(target)
            .children(".iama__selectbox--options")
            .hide();
        $(target)
            .children(".iama__selectbox--chevron-btn")
            .removeClass("show");
    }


    $(".iama__selectbox").on("click", function (e) {
        showOptions(e.currentTarget);
    });

    let selectBox = document.querySelector('.iama__selectbox');
    if (selectBox) {
        selectBox.addEventListener("keydown", (e) => {
            if (e.code.toLowerCase() === 'enter') {
                showOptions(e.currentTarget);
            }
        })
        selectBox.addEventListener('focusout', (e) => {
            if ($(selectBox).find(e.relatedTarget).length === 0) {
                hideOptions(e.currentTarget);
            }
        })
    }
}

export { init }